module.exports = __webpack_public_path__ + "static/img/Sym2.7889926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sym2.png
// module id = Q4zP
// module chunks = 36